<template>
  <div class="content">
    <el-row :gutter="20">
      <el-col :span="5">
        <div class="contentLeft">
          <ul>
            <li
              @click="jump(item)"
              class="menu"
              :class="{ active: item.id == id }"
              v-for="(item, index) in leftMenu"
              :key="index"
            >
              {{ item.itemText }}
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="19">
        <div class="contentRight">
          <div
            style="padding: 100px 0; text-align: center"
            v-if="rightList.totalCount == 0"
          >
            <img src="@/assets/img/kong.png" width="100px" />
            <p style="padding-top: 50px">暂无数据</p>
          </div>
          <ul>
            <li
              class="article"
              @click="article(item)"
              v-for="(item, index) in rightList.result"
              :key="index"
            >
              <div class="articleLeft">
                <img :src="item.coverPicture" width="100%" height="100%" />
              </div>
              <div class="articleRight">
                <div class="articleTitle beyondEllipsis">{{ item.title }}</div>
                <div class="articleConten beyondEllipsis3" style="height: 85px">
                  {{ content(item.content) }}
                </div>
                <!-- <div class="articleTime">
                  <span style="float:right;line-height:30px;">{{item.createDate}}</span>
                </div>-->
                <div class="time">
                  <p class="md">{{ item.createDate.slice(5, 10) }}</p>
                  <p class="year">{{ item.createDate.slice(0, 4) }}</p>
                  <span class="timeIcon"></span>
                </div>
                <div class="line"></div>
              </div>
            </li>
          </ul>
          <el-pagination
            background
            v-if="rightList.totalCount > 10"
            style="text-align: right; background: #fff"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageNo"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="rightList.totalCount"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { autoApi } from "@/api/home";
import router from "@/router/index";
export default {
  data() {
    return {
      input: "",
      pageNo: 1,
      pageSize: 10,
      menu: [],
      argumentsText: null,
      urlArr: [],
      leftMenu: [],
      rightList: {
        result: [],
      },
    };
  },
  created() {},
  computed: {
    content(text) {
      return (text) => {
        let objE = document.createElement("div");
        objE.innerHTML = text;
        return objE.innerText;
      };
    },
  },
  methods: {
    change(val) {
      this.pageNo = 1;
      this.getRightList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getRightList();
    },
    handleSizeChange(val) {
      this.pageNo = val;
      this.getRightList();
    },
    article(item) {
      let routerJump;

      routerJump = this.$router.resolve({
        name: "titleDetailPage",
        query: {
          id: -1,
          url: this.urlArr[2],
          pageViewId: item.pageViewId,
        },
      });

      window.open(routerJump.href, "_blank");

      // this.$router.push({
      //   path: "/titleDetailPage",
      //   query: {
      //     id: this.$route.query.id,
      //     url: this.urlArr[2],
      //     pageViewId: item.pageViewId
      //   }
      // });
    },
    jump(item) {
      item.pageUr = item.pageUr || "";
      if (item.pageUr.indexOf("www.") == 0) {
        window.open("http://" + item.pageUr);
        return;
      }
      if (item.pageUrl && item.pageUrl != "-") {
        this.$router.push({
          path: item.pageUrl,
          query: {
            id: item.id,
            url: item.argumentsText,
          },
        });
      }
    },
    getMenu() {
      let vm = this;
      vm.pageNo = 1;
      vm.urlArr = vm.argumentsText.split("\n");
      vm.getLeftList();
      vm.getRightList();

      vm.id = vm.$route.query.id;
      vm.$forceUpdate();
    },
    getLeftList() {
      autoApi(this.urlArr[0]).then((res) => {
        this.leftMenu = res;
        console.log(this.leftMenu);
      });
    },
    getRightList() {
      autoApi(this.urlArr[1], {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        retrieveArg: this.input,
      }).then((res) => {
        this.rightList = res;
        this.rightList.result.map((res) => {
          let objE = document.createElement("div");
          objE.innerHTML = res.content;
          res.content = objE.innerText;
        });

        console.log(this.rightList);
      });
    },
    getData() {
      if (this.$route.query.url) {
        this.argumentsText = this.$route.query.url;
        this.getMenu();
      }
      return;
      this.menu = this.$store.getters.menu;
      let argumentsText = "";
      for (let i = 0; i < this.menu.length; i++) {
        if (this.$route.query.id == this.menu[i].id) {
        } else {
          for (let j = 0; j < this.menu[i].children.length; j++) {
            if (this.$route.query.id == this.menu[i].children[j].id) {
              argumentsText = this.menu[i].children[j].argumentsText;
            }
          }
        }
      }
      if (argumentsText) {
        this.argumentsText = argumentsText;
        this.getMenu();
      }
    },
  },
  mounted() {
    const vm = this;
    router.beforeEach((to, from, next) => {
      console.log(to);
      console.log(from);
      console.log(next);
      if (to.path == "/leftMenuListPage") {
        setTimeout((res) => {
          vm.getData();
        }, 0);
      }
      next();
    });
    console.log(111111111);
    vm.getData();
  },
};
</script>

<style lang="less" scoped>
.content {
  margin: 0 auto;
  .contentLeft {
    background: #fff;

    .menu {
      background: rgb(235, 235, 235);
      margin-bottom: 10px;
      height: 58px;
      line-height: 58px;
      text-align: center;
      font-size: 18px;
      color: rgb(102, 102, 102);
      cursor: pointer;
    }
    .active {
      background: url(~@/assets/img/navActive.png) no-repeat;
      background-size: 100% 100%;
      color: #fff;
      margin-right: -9px;
    }
  }
  .contentRight {
    min-height: 400px;
    background: #fff;

    .article {
      cursor: pointer;

      height: 186px;

      margin-bottom: 10px;
      .articleLeft {
        float: left;
        height: 136px;
        width: 192px;
        background: #ddd;
        overflow: hidden;
      }
      .articleRight {
        border-bottom: 1px solid #ddd;
        float: right;
        height: 170px;
        width: 705px;
        position: relative;
        .articleConten {
          width: 510px;
          font-size: 14px;
          color: rgb(153, 153, 153);
          line-height: 30px;
        }
        .articleTime {
          position: absolute;
          height: 30px;
          width: 100%;
          bottom: 0;
        }
        .time {
          position: absolute;
          right: 50px;
          top: 50px;
          border-left: 1px solid #ddd;
          padding-left: 30px;
          padding: 10px 30px;
          .md {
            font-size: 24px;

            color: rgb(153, 153, 153);
            margin-bottom: 10px;
          }
          .year {
            color: rgb(153, 153, 153);
          }
          .timeIcon {
            position: absolute;
            width: 10px;
            height: 20px;
            top: 35px;
            right: -15px;
            background: url(~@/assets/img/back2.png) no-repeat;
            background-size: 100% 100%;
          }
        }
        .line {
          width: 4px;
          height: 136px;
          background: #395bc7;
          position: absolute;
          right: 10px;
          top: 15px;
          display: none;
        }
        &:hover {
          .md {
            color: rgb(57, 91, 190);
          }
          .line {
            display: block;
          }
          .timeIcon {
            background: url(~@/assets/img/back1.png) no-repeat;
            background-size: 100% 100%;
          }
          .articleTitle {
            color: rgb(57, 91, 190);
          }
        }
      }
      .articleTitle {
        font-size: 20px;
        width: 500px;
        line-height: 45px;
      }
    }
  }
}
</style>